import bondRequestsGrid from './bond-request-grid'
import bondRequestNew from './bond-request-new'
import bondRequestInfo from './bond-request-info'

export default function(nameAction, namePage){
    if(nameAction === 'bondrequestsgrid') {
        bondRequestsGrid();
        bondRequestNew();
    }
    if(nameAction === 'bondrequestinfo') bondRequestInfo();
}